import axios, { AxiosPromise } from 'axios';
import { ISezhlasovani } from 'types/akcionar';

export const hlasovaniAkcionarPut = (id: string, body: ISezhlasovani): AxiosPromise => {
    return axios({
        method: 'PUT',
        url: `Akcionar/${id}`,
        data: body
    });
};
export const hlasovaniAkcionarPost = (id: string, body: ISezhlasovani): AxiosPromise => {
    return axios({
        method: 'POST',
        url: `Akcionar/${id}`,
        data: body
    });
};
